/**
 * The run page's own strings, in both languages: the section headings and
 * the Day-2 action labels.
 */

import type { Language } from '../../../i18n/translations.js';

export type AnalysisRunPageCopy = ReturnType<typeof analysisRunPageCopy>;

export function analysisRunPageCopy(language: Language) {
  return language === 'ar'
    ? {
        back: 'العودة إلى التشغيلات',
        sources: 'مصادر النشاط',
        evidence: 'الأدلة الموحّدة',
        readiness: 'جاهزية التحليل',
        profile: 'مسودة ملف النشاط',
        acquire: 'جمع الأدلة وبناء المسودة',
        addSource: 'إضافة مصدر',
        saveCorrection: 'حفظ التصحيح',
        approve: 'اعتماد الملف',
        reject: 'رفض وطلب تصحيح',
        noEvidence: 'لم يتم جمع أدلة بعد.',
        unknowns: 'المجهول والقيود',
        conflicts: 'تعارضات تحتاج مراجعة',
        offers: 'العروض',
        addOffer: 'إضافة عرض',
        usage: 'الاستخدام والتكلفة',
        history: 'سجل المراجعة',
        competitors: 'اكتشاف المنافسين واعتمادهم',
        contentCollection: 'جمع محتوى النشاط والمنافسين',
      }
    : {
        back: 'Back to analysis runs',
        sources: 'Business sources',
        evidence: 'Normalized evidence',
        readiness: 'Analysis readiness',
        profile: 'Business Profile draft',
        acquire: 'Acquire evidence and build draft',
        addSource: 'Add source',
        saveCorrection: 'Save correction',
        approve: 'Approve profile',
        reject: 'Reject and request correction',
        noEvidence: 'No evidence has been acquired yet.',
        unknowns: 'Unknowns and constraints',
        conflicts: 'Conflicts requiring review',
        offers: 'Offers',
        addOffer: 'Add Offer',
        usage: 'Provider usage and cost',
        history: 'Review history',
        competitors: 'Competitor discovery and confirmation',
        contentCollection: 'Content collection',
      };
}
